module.exports = ".app-version {\r\n    color: #999;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/app-version/app-version.component.css
// module id = ./src/app/components/common/app-version/app-version.component.css
// module chunks = main